import { Value } from "@core/components/Value";
import { ResourceAllocation, SkillAllocation, StrengthAllocation, missingBudget } from "./parts";
import { useSm } from "./view";

/** Step 7: three budgets, worked through one after another – strengths, resources, skills (GRW p. 24). */
export function FreePointsStep() {
  const { view } = useSm();
  const allocation = view.freePoints;
  // The budgets come from the engine and already include race bonuses, refunds for doubled strengths and freed resource points.
  const budgets = view.allocationBudgets.frei ?? {};
  const strengths = budgets.strengths ?? missingBudget;
  const resources = budgets.resources ?? missingBudget;
  const skills = budgets.skills ?? missingBudget;
  return (
    <div className="stack">
      <section className="card stack">
        <h3>1. Stärken</h3>
        <p className="muted small">
          Wähle Stärken für <Value valueKey={strengths.total} /> Punkte. Stärken, die ein Modul doppelt vergibt, geben ihre Punkte hier zurück.
        </p>
        <StrengthAllocation step="frei" allocation={allocation} budget={strengths} />
      </section>
      <section className="card stack">
        <h3>2. Ressourcen</h3>
        <p className="muted small">
          Verteile <Value valueKey={resources.total} /> Punkte auf Ressourcen. Werte über {view.catalog?.limits.resourceApprovalAbove ?? 4} und negative Kernressourcen brauchen die Zustimmung des
          Spielleiters (GRW S. 24).
        </p>
        <ResourceAllocation step="frei" allocation={allocation} budget={resources} notes />
      </section>
      <section className="card stack">
        <h3>3. Fertigkeiten</h3>
        <p className="muted small">
          Verteile <Value valueKey={skills.total} /> Punkte auf beliebige Fertigkeiten, ohne das Höchstmaß von {view.catalog?.limits.skillMax ?? 6} je Fertigkeit zu überschreiten.
        </p>
        <SkillAllocation step="frei" allocation={allocation} budget={skills} />
      </section>
    </div>
  );
}
